<template>
    <div id="invoice-info-container">
        <div>
            <p class="dark-blue-text">{{ checkoutSharedContent.enterPaymentInfo.invoiceNote }} <span class="bold">{{ billing.email }}</span></p>
            <p class="mt-1 dark-blue-text mb-1">{{ checkoutSharedContent.enterPaymentInfo.invoiceDue }}</p>
            <p v-if="newBillingProcessApproved" class="mt-1 dark-blue-text mb-1">{{ checkoutSharedContent.enterPaymentInfo.newBillingProcessApproved }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    props: ['newBillingProcessApproved'],

    computed: {
        ...mapGetters('content', [
            'checkoutSharedContent'
        ]),
        ...mapGetters('billing', [
            'billing',
        ]),
    },
}
</script>
<style>
    #invoice-info-container {
        padding: 0 11px;
        margin-bottom: 50px;
    }
</style>